import i18next, { t } from "i18next";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EndPoints } from "../../../Constants/endpoints";
import TemplateIcon from "../../../assets/images/iconoir_stats-report.svg";
import arrow from "../../../assets/images/icons/arrow-down.svg";
import PlusIcon from "../../../assets/images/plus-square.svg";
import { InfiniteScroll } from "../../../components";
import { useAppMediaQuery } from "../../../hooks";
import PatientInfo from "../component/PatientInfo/PatientInfo";

export default function AddPatientMedicalRecord() {
  const navigate = useNavigate();
  const { PatientId } = useParams();
  const { isMobileOrTablet } = useAppMediaQuery();
  const [templatesData, setTemplatesData] = useState<any[]>();
  const [defaultTemplatesData, setDefaultTemplatesData] = useState<any[]>();

  return (
    <div
      className={`h-[100vh] bg-white p-6`}
      dir={i18next.language?.slice(0, 2) == "en" ? "ltr" : "rtl"}
    >
      <div className="mb-4 flex items-center justify-between">
        {PatientId && (
          <div className="flex cursor-pointer items-center gap-2">
            <div
              onClick={() => navigate("/patients_list", { replace: false })}
              className="h-6 w-6 rotate-90 rounded-full bg-primary rtl:-rotate-90"
            >
              <img src={arrow} alt="" className="brightness-0 invert" />
            </div>

            <h1 className="text-xl font-bold">{t("add_medical_report")}</h1>
          </div>
        )}
      </div>
      <div className="flex h-[96%] flex-1 gap-3 max-lg:flex-col">
        {PatientId && (
          <div className="py-3 lg:w-[22%]">
            <PatientInfo layout={isMobileOrTablet ? undefined : "sidebar"} />
          </div>
        )}
        <div
          className={`${PatientId ? "lg:w-[78%]" : "w-full"} max-h-[90vh] overflow-auto p-3`}
        >
          <div className="grid-col-1 grid max-h-[38vh] gap-6 overflow-auto sm:grid-cols-2 lg:grid-cols-4">
            {defaultTemplatesData?.map((template: any, i: number) => (
              <div key={i} className="flex flex-wrap gap-6">
                <div
                  className="flex h-40 w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-primary !p-6 hover:brightness-110"
                  onClick={() => {
                    PatientId
                      ? navigate(
                          `/patient/${PatientId}/add-medical-record/${template?.Id}`,
                        )
                      : navigate(
                          `/medical-record-templates/${template?.Id}/customize`,
                        );
                  }}
                >
                  <img alt="plus" src={PlusIcon} />
                  <div className="text-sm font-bold !text-white">
                    {template?.Name}
                  </div>
                </div>
              </div>
            ))}
            <InfiniteScroll
              Count={10}
              skeletonCount={4}
              endpoint={EndPoints.MedicalHistoryTypes}
              getAllParams={{
                IsGeneralMedical: true,
              }}
              getData={(data) => setDefaultTemplatesData(data)}
              renderSkeleton={
                <div className="h-40 animate-pulse rounded-lg bg-gray-400"></div>
              }
            />
          </div>
          <div className="mt-8">
            <h2 className="mb-4 font-bold">{t("my_templates")}</h2>

            <div className="grid-col-1 grid max-lg:max-h-[32vh] gap-6 overflow-auto sm:grid-cols-2 lg:grid-cols-4">
              {templatesData?.map((template: any, i: number) => (
                <div
                  key={i}
                  className="flex h-40 cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border border-white hover:border-primary"
                >
                  <div
                    className="align-center bg-primary-bg flex h-full w-full justify-center gap-2 rounded-lg !p-6"
                    onClick={() => {
                      PatientId
                        ? navigate(
                            `/patient/${PatientId}/add-medical-record/${template?.Id}`,
                          )
                        : navigate(
                            `/medical-record-templates/${template?.Id}/customize`,
                          );
                    }}
                  >
                    <img className="w-6" alt="template" src={TemplateIcon} />
                  </div>
                  <p className="mt-1 pb-1 text-sm font-bold">
                    {template?.Name || "Unknown Template"}
                  </p>
                </div>
              ))}
              <InfiniteScroll
                Count={10}
                skeletonCount={4}
                endpoint={EndPoints.MedicalHistoryTypes}
                getAllParams={{
                  IsGeneralMedical: false,
                }}
                getData={(data) => setTemplatesData(data)}
                renderSkeleton={
                  <div className="h-40 animate-pulse rounded-lg bg-gray-400"></div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
